import { authHttpClient } from "@webmotors/consumer-shared-auth";
import { setupAxiosObservability } from "@webmotors/anunciar.tools";
import { ENV } from "@/app/config";

authHttpClient.defaults.baseURL = ENV.API_BASE_URL;
authHttpClient.defaults.timeout = 30_000;

/**
 * Injeta `x-correlation-id` em toda request via interceptor de `@webmotors/anunciar.tools`.
 * O correlation-id vive em `sessionStorage` (UUID v4 gerado por `getCorrelationId`),
 * permitindo rastrear o fluxo completo do usuário no backend/Datadog.
 */
setupAxiosObservability(authHttpClient);

const httpClient = authHttpClient;

export { httpClient };
